export class MArtwork {
    "id": string;
    "designNo": string;
    "designTypeId": string;
    "orderId": string;
    "assignedId": string;
    "customerId": string;
    "accountId": string;
    "estimated": string;
    "dueDate": string;
    "createdDate": string;
    "priority": string;
    "statusId": string;
    "identity": string;
    "category": string;
    "color": string;
    "image": string;
    "notes": string;
    "featureImage": string;
    "designId": string;
    "assignee": string;
    "orderNum": string;
    "orderIdentity": string;
    "customerName": string;
    "designTypeName": string;
    "statusName": string;
    "statusLabel": string;
    "artworkContactId": string;
    "artworkContactName": string;
    "artworkContactEmail": string;
    "royaltyRetail": string;
    "royaltyRetailAmountType": string;
    "royaltyWholesale": string;
    "royaltyWholesaleAmountType": string;
    "pinned": string;
    "projectId": string;
    "projectName": string;
    "approvedBy": string;
    "dateApproved": string;
    usageStatus: string;
    "design": {
        "id": string;
        "name": string;
        "description": string;
        "url": string;
        "isMaster": string;
        "dateCreated": string;
        "dateModified": string;
        "deleted": string;
        "model": string;
        "designType": string;
        "designFormType": string;
        "customerId": string;
        "customerName": string;
        "decoVendorId": string;
        "decoVendorName": string;
        "decoVendorNo": string;
        "color": string;
        "typeFiles": string;
        "location": string;
        "stitchCount": number;
        "decoDetailCountName": string;
        "savedToDisk": string;
        "variation": ArtworkVariation[];
        "size": string;
        "designDescriptionStitches": string;
        "colorThread": string;
        "notes": string;
        "orderNumbers": string;
        "relatedOrders": RelatedOrders[];
        "designImages": string[];
    };
    "relatedOrders": InnerRelatedOrders[];
    "thumbnail": string;

    constructor(options){
        this.id = options.id || "";
        this.designNo = options.designNo || "";
        this.designTypeId = options.designTypeId || "";
        this.usageStatus = options.usageStatus || "";
        this.orderId = options.orderId || "";
        this.assignedId = options.assignedId || "";
        this.customerId = options.customerId || "";
        this.accountId = options.accountId || "";
        this.estimated = options.estimated || "";
        this.dueDate = options.dueDate || "";
        this.createdDate = options.createdDate || "";
        this.priority = options.priority || "";
        this.statusId = options.statusId || "";
        this.identity = options.identity || "";
        this.category = options.category || "";
        this.color = options.color || "";
        this.image = options.image || "";
        this.notes = options.notes || "";
        this.featureImage = options.featureImage || "";
        this.designId = options.designId || "";
        this.assignee = options.assigne || "";
        this.orderNum = options.orderNum || "";
        this.orderIdentity = options.orderIdentity || "";
        this.customerName = options.cutomerName || "";
        this.designTypeName = options.designTypeName || "";
        this.statusName = options.statusName || "";
        this.statusLabel = options.statusLabel || "";
        this.artworkContactId = options.artworkContactId || "";
        this.artworkContactEmail = options.artworkContactEmail || "";
        this.royaltyRetail = options.royaltyRetail || "";
        this.royaltyWholesale = options.royaltyWholesale || "";
        this.royaltyWholesaleAmountType = options.royaltyWholesaleAmountType || "";
        this.pinned = options.pinned || "";
        this.projectId = options.projectId || "";
        this.projectName = options.projectName || "";
        this.design = {
          id: options.design.id || "",
          name: options.design.name || "",
          description: options.design.description || "",
          url: options.design.url || "",
          isMaster: options.design.isMaster || "",
          dateCreated: options.design.dateCreated || "",
          dateModified: options.design.dateModified || "",
          deleted: options.design.deleted || "",
          model: options.design.model || "",
          designType: options.design.designType || "",
          designFormType: options.design.designFormType || "",
          customerId: options.design.customerId || "",
          customerName: options.design.customerName || "",
          decoVendorId: options.design.decoVendorId || "",
          decoVendorName: options.design.decoVendorName || "",
          decoVendorNo: options.design.decoVendorNo || "",
          color: options.design.color || "",
          typeFiles: options.design.typeFiles || "",
          location: options.design.location || "",
          stitchCount: options.design.stitchCount || 0,
          decoDetailCountName: options.design.decoDetailCountName || "",
          savedToDisk: options.design.savedToDisk || "",
          variation: options.design.variation.map(
            (variation) => new ArtworkVariation(variation)
          ),
          size: options.design.size || "",
          designDescriptionStitches: options.design.designDescriptionStitches || "",
          colorThread: options.design.colorThread || "",
          notes: options.design.notes || "",
          orderNumbers: options.design.orderNumbers || "",
          relatedOrders: options.design.relatedOrders.map(relatedOrder => new RelatedOrders(relatedOrder)),
          designImages: options.design.designImages || []
        };
        this.relatedOrders = options.relatedOrders.map(relatedOrder => new InnerRelatedOrders(relatedOrder));
        this.thumbnail = options.thumbnail || "";
        this.approvedBy = options.approvedBy || "";
        this.dateApproved = options.dateApproved || "";
    }
}

export class RelatedOrders {
    "order_number": string;
    "order_id": string;
    "vendor_id": string;
    constructor(options){
        this.order_number = options.order_number || "";
        this.order_id = options.order_id || "";
        this.vendor_id = options.vendor_id || "";
    }
}

export class InnerRelatedOrders {
    "orderId": string;
    "orderNum": string;
    "orderIdentity": string;
    "designId": string;
    "designModal": string;
    constructor(options){
        this.orderId = options.orderId || "";
        this.orderNum = options.orderNum || "";
        this.orderIdentity = options.orderIdentity || "";
        this.designId = options.designId || "";
        this.designModal = options.designModal || "";
    }
}

export class ArtworkVariation {
    "design_variation_unique_id": string;
    "design_variation_title": string;
    "itemImage": string[];
    "itemImageThumbnail": string[];
    "design_variation_product": string;
    "design_variation_color": string;
    "design_variation_location": string;
    "design_note": string;
    "design_color_thread_pms": string[];

    constructor(options){
        this.design_variation_unique_id = options.design_variation_unique_id || "";
        this.design_variation_title = options.design_variation_title || "";
        this.itemImage = options.itemImage || [];
        this.itemImageThumbnail = options.itemImageThumbnail || [];
        this.design_variation_product = options.design_variation_product || "";
        this.design_variation_color = options.design_variation_color || "";
        this.design_variation_location = options.design_variation_location || "";
        this.design_note = options.design_note || "";
        this.design_color_thread_pms = options.design_color_thread_pms || [];
    }
}